
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/dispatching",
      function () {
        return require("private-next-pages/dispatching/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/dispatching"])
      });
    }
  